import React, { useContext, useState, useEffect } from 'react';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import { EnquiryContext } from 'venuescanner-js/react/components/Inbox/context/EnquiryContext';
import { inboxStatus } from 'venuescanner-js/constants/thread';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';

const EnquiryFilter = () => {
  const { counts } = useContext(EnquiryContext);
  const { threadsFilter, setThreadsFilter } = useContext(ViewContext);
  const [lastThreadFilter, setLastThreadFilter] = useState(threadsFilter[0]);

  useEffect(() => {
    if (lastThreadFilter !== threadsFilter[0]) {
      inboxService.threads();
      setLastThreadFilter(threadsFilter[0]);
    }
  }, [threadsFilter, lastThreadFilter]);

  const filters = Object.values(inboxStatus).map(option => {
    return (
      <button
        key={option}
        className={`enquiry-filter__item ${
          threadsFilter[0] === option ? 'isActive' : ''
        }`}
        onClick={() => {
          setThreadsFilter([option]);
        }}>
        <span className='enquiry-filter__item-content'>
          {counts[option] && counts[option]['total']
            ? counts[option]['total'] > 99
              ? `${option}: 99+`
              : `${option}: ${counts[option]['total']}`
            : option}
          {counts[option]?.awaiting ? (
            <span className='enquiry-filter__count'></span>
          ) : null}
        </span>
      </button>
    );
  });

  return <div className='enquiry-filter'>{filters}</div>;
};

export default EnquiryFilter;
